import { Link } from "react-router-dom";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function NotFoundPage() {
  useDocumentTitle("Not found — Pilot Mastery Academy");

  return (
    <div className="mx-auto max-w-6xl px-4 py-24 text-center">
      <h1 className="font-display text-3xl font-semibold text-white">Page not found</h1>
      <Link to="/" className="mt-6 inline-block text-signal-sky hover:underline">
        Return home
      </Link>
    </div>
  );
}
